import ApiService from '../../utils/base-api/api-service';
import RequestConfig from '../../utils/base-api/request-config';
import { AddProductToCategoryDto } from './dtos/add-product-category-dto';
import { CategoryDetailsDto } from './dtos/category-details';
import { CategoryDto } from './dtos/category-dto';
import { CategoryProductsDto } from './dtos/category-products-dto';
import { CreateCategoryDto } from './dtos/create-category-dto';
import { ProductsFilterDto } from './dtos/products-filter-dto';
import { ProductsInfoDto } from './dtos/products-info-dto';
import { CategoryProductModelsDto } from './dtos/category-products-dto';
import { CategoryProductsParamsDto } from './dtos/category-products-params-dto';

class CategoriesService extends ApiService {
  constructor() {
    super({
      baseURL: '/AdminCategory',
    });
  }

  getAll(
    params?: Record<string, unknown>,
    config?: RequestConfig,
  ): Promise<Array<CategoryDto>> {
    return this.get('/NodeList', { params, ...config });
  }

  create(input: CreateCategoryDto) {
    return this.post('/Create', input);
  }

  edit(input: CreateCategoryDto) {
    return this.put('/Edit', input);
  }

  getCategoryById(input: string): Promise<CategoryDetailsDto> {
    return this.get('/GetCategoryByID', { params: { id: input } });
  }

  deleteCategory(input: string) {
    return this.delete('/Delete', { params: { id: input } });
  }

  exportToExcel() {
    return this.get('/ExportXlsx', {
      responseType: 'arraybuffer',
    });
  }

  categoryProductList(
    input: CategoryProductsParamsDto,
  ): Promise<CategoryProductsDto> {
    return this.get('/ProductList', { params: input });
  }

  addProductToCategory(input: AddProductToCategoryDto) {
    return this.post('/ProductAddPopup', input);
  }

  productListAddPopup(input: ProductsFilterDto): Promise<ProductsInfoDto> {
    return this.post('/ProductAddPopupList', input);
  }

  productUpdate(input: CategoryProductModelsDto) {
    return this.put('/ProductUpdate', input);
  }

  productDelete(input: CategoryProductModelsDto) {
    return this.post('/ProductDelete', input);
  }
}

export const categoriesService = new CategoriesService();
